import { forwardRef, useEffect, useState } from "react";
import css from "../SelectDate/SelectDate.module.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsCalendar2Week } from "react-icons/bs";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import { format, addDays, subDays, isBefore, startOfDay } from "date-fns";
import { useSelector } from "react-redux";
import { selectDate } from "../../../../redux/cars/selectors";

export default function SelectDate({ value, onChange }) {
  const CustomInput = forwardRef(({ value: date, onClick }, ref) => (
    <div className={css.datePickerWrapper}>
      <button
        type="button"
        className={css.datePaginationBtn}
        onClick={() => onChange(subDays(date, 1))}
        disabled={isBefore(subDays(date, 1), startOfDay(new Date()))}
      >
        <BsChevronLeft className={css.btnIcon} />
      </button>

      <div className={css.dateWrapper}>
        <button
          type="button"
          className={css.customInput}
          onClick={onClick}
          ref={ref}
        >
          <BsCalendar2Week />
        </button>
        <p>{format(date, "dd.MM.yyyy")}</p>
      </div>

      <button
        type="button"
        className={css.datePaginationBtn}
        onClick={() => onChange(addDays(date, 1))}
      >
        <BsChevronRight className={css.btnIcon} />
      </button>
    </div>
  ));

  CustomInput.displayName = "CustomInput";

  return (
    <DatePicker
      selected={value}
      onChange={onChange}
      minDate={new Date()}
      customInput={<CustomInput />}
    />
  );
}
